<template>
  <div class="card" v-if="datos.length">
    <div class="card-header pb-0">
      <h6>Colboradores Sin Asignar</h6>
    </div>
    <div class="card-body px-0 pt-0 pb-2">
      <div class="table-responsive p-0">
        <table class="table align-items-center mb-0">
          <thead>
            <tr>
              <th
                class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
              >
                Nombre
              </th>
              <th
                class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
              >
                Telefono
              </th>
              <th
                class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
              >
                Correo
              </th>
              <th
                class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
              >
                Estado/Municipio
              </th>
              <th
                class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
              >
                Acción
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="c in datos" :key="c.id">
              <td class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">{{ c.nombre }} {{ c.paterno }} {{ c.materno }}</td>
              <td class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"> {{ c.telefono }}</td>
              <td class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">{{ c.email }}</td>
              <td class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">{{ c.estado }} {{ c.delegacion }}</td>
              <td class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                <button
                  type="button"
                  class="btn btn-success"
                  @click="altaColaborador(c.id)"
                >
                  Agregar Colaborador
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <div class="card" >
    <div class="card-header pb-0">
      <h6>Mis Colaboradores</h6>
    </div>
    <div class="card-body px-0 pt-0 pb-2">
      <div class="table-responsive p-0">
        <table class="table align-items-center mb-0">
          <thead>
            <tr>
              <th
                class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
              >
                Nombre
              </th>
              <th
                class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
              >
                Telefono
              </th>
              <th
                class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
              >
                Correo
              </th>
              <th
                class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
              >
                Estado/Municipio
              </th>
              <th
                class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
              >
                Acción
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="c in datosColaboradores" :key="c.id">
              <td class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">{{ c.nombre }} {{ c.paterno }} {{ c.materno }}</td>
              <td class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">{{ c.telefono }}</td>
              <td class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">{{ c.email }}</td>
              <td class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">{{ c.estado }} {{ c.delegacion }}</td>
              <td>
                
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import Swal from "sweetalert2";
import agente from "../../api/colaboradores";
export default {
  async mounted() {
    await this.getColaboradores();
    await this.misColaboradores();
  },
  data() {
    return {
      datosColaboradores:[],
      datos: [],
      model: {
        id: "",
      },
      setData: {
        id: "",
        gerente: "",
      },
    };
  },
  methods: {
    getColaboradores() {
      this.datos=[]
      this.model.gerente = localStorage.getItem("id");
      agente
        .colaboradores(this.model)
        .then((result) => {
          this.datos = result.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    misColaboradores() {
      this.datosColaboradores=[]
      this.model.gerente = localStorage.getItem("id");
      agente
        .misColaboradores(this.model)
        .then((result) => {
          this.datosColaboradores = result.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    altaColaborador(id) {
      Swal.fire({
        title: "Asignar Colaborador",
        text:
          "¿Deseas asignar al colaborador con id :" +
          id +
          " colaborador a tu equipo?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "success",
        confirmButtonText: "Continuar",
        cancelButtonText: "Cancelar",
      }).then((resultado) => {
        if (resultado.value) {
          this.setColaborador(id);
        }
      });
    },
    setColaborador(id) {
      this.setData.gerente = localStorage.getItem("id");
      this.setData.id = id;
      agente
        .setColaborador(this.setData)
        .then((result) => {
          console.log(result.data[0]);
          if (result.data == "Success") {
            Swal.fire({
              title: "Asignacion correcta",
              text: "Asignacion correcta de colaborador",
              icon: "success",
              confirmButtonColor: "success",
              confirmButtonText: "Continuar",
            });
            
          } else {
            Swal.fire({
              title: "Error en asignacion",
              text: "Hubo error en asignacion",
              icon: "danger",
              confirmButtonColor: "danger",
              confirmButtonText: "Continuar",
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });

      this.getColaboradores();
      this.misColaboradores();
      this.setData.id = "";
      this.setData.gerente = "";
    },
  },
};
</script>
